const IMMEDIATE_LOCK_WAIT_MS = 1500;
export function createSupabaseAuthLock() {
    return async (name, acquireTimeout, fn) => {
        var _a;
        const locks = (_a = globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks;
        if (!locks) {
            return fn();
        }
        const timeoutMs = acquireTimeout === 0 ? IMMEDIATE_LOCK_WAIT_MS : acquireTimeout;
        if (timeoutMs < 0) {
            return locks.request(name, { mode: 'exclusive' }, fn);
        }
        const abortController = new AbortController();
        const timeout = setTimeout(() => abortController.abort(), timeoutMs);
        try {
            return await locks.request(name, { mode: 'exclusive', signal: abortController.signal }, fn);
        }
        finally {
            clearTimeout(timeout);
        }
    };
}
